import { render, staticRenderFns } from "./EventModalCatalogExample.vue?vue&type=template&id=55401758&scoped=true"
import script from "./EventModalCatalogExample.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogExample.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogExample.vue?vue&type=style&index=0&id=55401758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55401758",
  null
  
)

export default component.exports